import { triggerIdentifyEvent } from '@/features/analytics/events/utils/triggerIdentifyEvent';
import { profileSDK } from '@/sdk/client/profileSDK';

import { mvpdLogOut } from './mvpdLogOut';

/**
 * Soft logout function.
 * This will only clear the session on fox.com (we usually want to do this when we encounter an expired token, or other kinds of invalid sessions).
 */
export async function softLogOut(): Promise<void> {
  try {
    await mvpdLogOut();
    await profileSDK.logout({});
    void triggerIdentifyEvent({ trigger: 'logout', dma: BigInt(window.__APP_LAUNCH_FIRED_DMA ?? '') });
  } catch {}
}
